import { BuilderElement, GlobalConfig, ElementType } from "../types/builder";
import { generateId } from "../utils/builder";
import { createListingSection } from "./template2";

// ====================== Alert Message Section ======================
const alertMsg = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "upsell-banner",
  styles: {
    backgroundImage:
      "linear-gradient(to right, #9b1c1c, #dc2626, #990000, #dc2626)",
    textAlign: "center",
    padding: "12px 0 ",
    width: "100%",
  },
  responsiveStyles: {
    tablet: {
      padding: "10px 0 15px 0",
    },
    mobile: {
      padding: "12px 0 18px 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "paragraph" as ElementType,
      content: "SPECIAL OFFER ENDS IN: XX:21 - BUY NOW!",
      styles: {
        color: "#fbbf24",
        fontFamily: "SF Pro Display, sans-serif",
        fontSize: "28px",
        fontWeight: "700",
        lineHeight: "100%",
        margin: "0",
      },
      responsiveStyles: {
        tablet: { fontSize: "20px" },
        mobile: {
          fontSize: "16px",
        },
      },
    },
  ],
});

// ====================== Banner Section ======================
const banner = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "offer-header",
  styles: {
    backgroundImage:
      "radial-gradient(circle at center 20%, #7acdeb, #21acde, #1e9ac8, #1b89b1)",
    padding: "94px 0",
    textAlign: "center",
    fontFamily: "SF Pro Display, sans-serif",
  },
  responsiveStyles: {
    tablet: {
      padding: "60px 0",
    },
    mobile: {
      padding: "40px 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "container",
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 16px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "header-container",
          styles: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "55px 0",
          },
          responsiveStyles: {
            tablet: { gap: "30px 0" },
            mobile: { gap: "20px 0" },
          },
          children: [
            // Logo Image
            {
              id: generateId(),
              type: "logo" as ElementType,
              styles: {
                maxWidth: "336px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              responsiveStyles: {
                mobile: { maxWidth: "224px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/intellident/group1.png",
                  alt: "Fortigold Logo",
                  styles: {
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  },
                },
              ],
            },
            // Header Text
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "header",
              styles: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px 0",
              },
              children: [
                // Main Title
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "CONGRATULATIONS!",
                  styles: {
                    color: "background",
                    fontSize: "50px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    lineHeight: "100%",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "38px" },
                    mobile: {
                      fontSize: "24px",
                    },
                  },
                },
                // Subtitle
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "YOU HAVE UNLOCKED A BONUS OFFER",
                  styles: {
                    color: "background",
                    fontSize: "50px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    lineHeight: "100%",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "38px" },
                    mobile: {
                      fontSize: "24px",
                    },
                  },
                },
              ],
            },
            // Warning Text
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "DO NOT CLOSE THIS PAGE! IT MAY CAUSE AN ERROR IN YOUR CONFIRMATION!",
              styles: {
                color: "background",
                fontFamily: "SF Pro Display, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "28px",
                marginTop: "-35px",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "20px",
                  lineHeight: "24px",
                  marginTop: "0",
                },
                mobile: {
                  fontSize: "18px",
                  lineHeight: "22px",
                  marginTop: "0",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

// ====================== Content Section ======================
const content = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "offer-sub-header",
  styles: {
    backgroundColor: "rgba(242, 242, 243, 1)",
    padding: "50px 0",
    textAlign: "center",
  },
  responsiveStyles: {
    tablet: {
      padding: "40px 0",
    },
    mobile: {
      padding: "30px 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "container",
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 16px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "header-container",
          styles: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "50px 0",
          },
          responsiveStyles: {
            tablet: { gap: "30px 0" },
            mobile: { gap: "20px 0" },
          },
          children: [
            // Main Title
            {
              id: generateId(),
              type: "heading" as ElementType,
              content:
                '<span style="color: #ed1c24;">WAIT!</span> Before we ship your order... unlock FORTIGOLD\'s full healing power with this <span style="color: #051168;">ONE-TIME</span> offer',
              styles: {
                color: "#231F20",
                fontSize: "48px",
                fontStyle: "normal",
                fontFamily: "SF Pro Display, sans-serif",
                fontWeight: "900",
                lineHeight: "1.375",
                margin: "0",
                maxWidth: "950px",
              },
              responsiveStyles: {
                tablet: { fontSize: "38px" },
                mobile: {
                  fontSize: "20px",
                },
              },
            },
            // Subtitle
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Your brain and gums need more than 30 days to fully reset and repair - this is your chance to lock in long-term cognitive and oral support at the lowest price we'll ever offer.",
              styles: {
                color: "#231F20",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "28px",
                maxWidth: "1044px",
                margin: "0",
              },
              responsiveStyles: {
                tablet: { fontSize: "20px" },
                mobile: {
                  fontSize: "16px",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

// ====================== Features Box Section ======================
const featuresBoxSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "features-box",
  styles: {
    margin: "100px 0 30px",
    width: "100%",
  },
  responsiveStyles: {
    tablet: { margin: "60px 0 30px" },
    mobile: { margin: "30px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "container",
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 15px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "features-box-container",
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "30px 0",
          },
          responsiveStyles: {
            mobile: { gap: "16px 0" },
          },
          children: [
            // Feature Box
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "feature-box",
              styles: {
                border: "1px solid #808285",
                width: "100%",
              },
              children: [
                // Feature Header
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  className: "feature-header",
                  styles: {
                    backgroundImage:
                      "linear-gradient(to right, #1e9dc8 60%, #65c6e7 80%, #37b4e1 90%)",
                    padding: "32px 0",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    mobile: { padding: "16px 0" },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      dynamicContentId: "__dynamic__bottle_count__",
                      content:
                        "This is your ONLY chance to secure 3 extra bottles for just $39 each — over 43% OFF.",
                      styles: {
                        maxWidth: "926px",
                        color: "background",
                        textAlign: "center",
                        fontSize: "40px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "48px",
                        margin: "0",
                      },
                      typography: "Heading-4",
                      responsiveStyles: {
                        mobile: { fontSize: "24px", lineHeight: "28px" },
                      },
                    },
                  ],
                },
                // Feature Body
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  className: "feature-body",
                  styles: {
                    padding: "40px",
                    backgroundColor: "#DBDBDB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      flexDirection: "column",
                      padding: "20px",
                      gap: "20px",
                    },
                    mobile: {
                      padding: "10px",
                      flexDirection: "column",
                      gap: "10px",
                    },
                  },
                  children: [
                    // Image Container
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      className: "img-container",
                      styles: {
                        flex: "1 1 calc(50% - 16px)",
                      },
                      responsiveStyles: {
                        mobile: { flex: "1 1 100%" },
                        tablet: { flex: "1 1 100%" },
                      },

                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          dynamicContentId: "__dynamic__bottle_image__",
                          src: "/intellident/3 bottles.png",
                          alt: "3 Bottles of Intellident Pro",
                          styles: {
                            maxWidth: "90%",
                            width: "100%",
                            margin: "0 auto",
                          },
                          responsiveStyles: {
                            mobile: { maxWidth: "100%" },
                          },
                        },
                      ],
                    },
                    // Content Body
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      className: "content-body",
                      styles: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        gap: "30px 0",
                        flex: "1 1 calc(50% - 16px)",
                      },
                      responsiveStyles: {
                        mobile: {
                          gap: "16px 0",
                          flex: "1 1 100%",
                          width: "100%",
                          alignItems: "center",
                        },
                        tablet: {
                          flex: "1 1 100%",
                          width: "100%",
                          alignItems: "center",
                        },
                      },
                      children: [
                        // Feature List
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          className: "feature-list",
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            gap: "20px 0",
                          },
                          responsiveStyles: {
                            mobile: { gap: "16px 0" },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                color: "#231F20",
                                fontSize: "24px",
                                fontStyle: "normal",
                                fontWeight: "600",
                                lineHeight: "26px",
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "flex-start",
                                gap: "0 10px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "22px",
                                  lineHeight: "30px",
                                },
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "text" as ElementType,
                                  content: "🔥",
                                  styles: {},
                                },
                                {
                                  id: generateId(),
                                  type: "text" as ElementType,
                                  dynamicContentId:
                                    "__dynamic__offer_description__",
                                  content:
                                    "🔥 Get 3 more Bottles of Intellident ProTM for just $117 Total (Only $29 Each!)",
                                  styles: {
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    lineHeight: "26px",
                                  },
                                  responsiveStyles: {
                                    mobile: {
                                      fontSize: "16px",
                                      lineHeight: "20px",
                                    },
                                    tablet: {
                                      fontSize: "20px",
                                      lineHeight: "24px",
                                    },
                                  },
                                },
                              ],
                            },
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                color: "#231F20",
                                fontSize: "24px",
                                fontStyle: "normal",
                                fontWeight: "600",
                                lineHeight: "26px",
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "flex-start",
                                gap: "0 10px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "22px",
                                  lineHeight: "30px",
                                },
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "image" as ElementType,
                                  src: "/intellident/group-1.png ",
                                  styles: { width: "24px", height: "24px" },
                                },
                                {
                                  id: generateId(),
                                  type: "text" as ElementType,
                                  dynamicContentId:
                                    "__dynamic__offer_option_1__",
                                  content:
                                    "That's less than half the price of buying later",
                                  styles: {
                                    fontSize: "20px",
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    lineHeight: "26px",
                                  },
                                  responsiveStyles: {
                                    mobile: {
                                      fontSize: "16px",
                                      lineHeight: "20px",
                                    },
                                    tablet: {
                                      fontSize: "20px",
                                      lineHeight: "24px",
                                    },
                                  },
                                },
                              ],
                            },
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                color: "#231F20",
                                fontSize: "24px",
                                fontStyle: "normal",
                                fontWeight: "600",
                                lineHeight: "26px",
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "flex-start",
                                gap: "0 10px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "22px",
                                  lineHeight: "30px",
                                },
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "image" as ElementType,
                                  src: "/intellident/group-1.png ",
                                  styles: { width: "24px", height: "24px" },
                                },
                                {
                                  id: generateId(),
                                  type: "text" as ElementType,
                                  dynamicContentId:
                                    "__dynamic__offer_option_2__",
                                  content:
                                    "Build a 90-day brain-repair routine",
                                  styles: {
                                    fontSize: "20px",
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    lineHeight: "26px",
                                  },
                                  responsiveStyles: {
                                    mobile: {
                                      fontSize: "16px",
                                      lineHeight: "20px",
                                    },
                                    tablet: {
                                      fontSize: "20px",
                                      lineHeight: "24px",
                                    },
                                  },
                                },
                              ],
                            },
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                color: "#231F20",
                                fontSize: "24px",
                                fontStyle: "normal",
                                fontWeight: "600",
                                lineHeight: "26px",
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "flex-start",
                                gap: "0 10px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "22px",
                                  lineHeight: "30px",
                                },
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "image" as ElementType,
                                  src: "/intellident/group-1.png ",
                                  styles: { width: "24px", height: "24px" },
                                },
                                {
                                  id: generateId(),
                                  type: "text" as ElementType,
                                  dynamicContentId:
                                    "__dynamic__offer_option_3__",
                                  content:
                                    "Avoid backorders and stay consistent",
                                  styles: {
                                    fontSize: "20px",
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    lineHeight: "26px",
                                  },
                                  responsiveStyles: {
                                    mobile: {
                                      fontSize: "16px",
                                      lineHeight: "20px",
                                    },
                                    tablet: {
                                      fontSize: "20px",
                                      lineHeight: "24px",
                                    },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        // CTA Button
                        {
                          id: generateId(),
                          type: "button" as ElementType,
                          className: "pay-btn",
                          dynamicContentId: "__dynamic__button_offer__",
                          content: "YES — Add 3 More Bottles for Just $117",
                          styles: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "12px 24px",
                            borderRadius: "14.568px",
                            backgroundImage:
                              "conic-gradient(from 72deg at 33.42% 100%, #f49d00 5.3999998793deg, #ffaf1a 196.2000060081deg, #fcc709 360deg)",
                            overflow: "hidden",
                            color: "#231F20",
                            textAlign: "center",
                            fontSize: "24px",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "28px",
                            fontFamily: "SF Pro Display, sans-serif",
                          },
                          responsiveStyles: {
                            tablet: { alignSelf: "center" },
                            mobile: { fontSize: "16px", height: "50px" },
                          },
                        },
                        // Payment Methods
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: { textAlign: "center", width: "100%" },
                          children: [
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: { display: "flex", width: "100%" },
                              responsiveStyles: {
                                mobile: {
                                  justifyContent: "center",
                                  alignItems: "center",
                                },
                                tablet: {
                                  justifyContent: "center",
                                  alignItems: "center",
                                },
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "container" as ElementType,
                                  styles: {
                                    position: "relative",
                                    display: "inline-block",
                                    width: "350px",
                                    padding: "0 8px",
                                    margin: "0 8px",
                                  },
                                  children: [
                                    {
                                      id: generateId(),
                                      type: "image" as ElementType,
                                      src: "/intellident/vector-1401.svg",
                                      alt: "Payment Methods Background",
                                      styles: { width: "100%" },
                                    },
                                    {
                                      id: generateId(),
                                      type: "container" as ElementType,
                                      styles: {
                                        position: "absolute",
                                        inset: 0,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                        padding: "8px",
                                        top: "-12px",
                                      },
                                      children: [
                                        {
                                          id: generateId(),
                                          type: "paragraph" as ElementType,
                                          content: "GUARANTEED SAFE CHECKOUT",
                                          styles: {
                                            fontSize: "12px",
                                            marginTop: "-16px",
                                            letterSpacing: "-0.01em",
                                            lineHeight: "1",
                                          },
                                        },
                                        {
                                          id: generateId(),
                                          type: "container" as ElementType,
                                          styles: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                          },
                                          children: [
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/Asset7.webp",
                                              alt: "McAfee",
                                              styles: { height: "20px" },
                                            },
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/clip-path-group-4.webp",
                                              alt: "PayPal",
                                              styles: { height: "20px" },
                                            },
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/kamqdp-1.webp",
                                              alt: "Visa",
                                              styles: { height: "20px" },
                                            },
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/Asset 7.webp",
                                              alt: "American Express",
                                              styles: { height: "20px" },
                                            },
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/rectangle-1.webp",
                                              alt: "MasterCard",
                                              styles: { height: "20px" },
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // Feature Box Text
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              className: "feature-box-text",
              content:
                '<a href="#">No thanks, I\'ll pass on this special offer</a>',
              styles: {
                color: "forground",
                textAlign: "center",
                fontSize: "22px",
                fontStyle: "italic",
                fontWeight: "400",
                lineHeight: "100%",
                fontFamily: "SF Pro Display, sans-serif",
                margin: "0",
                textDecoration: "underline",
              },
              responsiveStyles: {
                mobile: { fontSize: "16px" },
              },
            },
          ],
        },
      ],
    },
  ],
});

// ====================== Message Section ======================
const msgSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "msg-box",
  styles: {
    margin: "30px 0 100px",
    width: "100%",
  },
  responsiveStyles: {
    tablet: { margin: "30px 0 50px" },
    mobile: { margin: "30px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "container",
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 16px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "msg-box-container",
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "54px 0",
          },
          responsiveStyles: {
            tablet: { gap: "30px 0" },
            mobile: { gap: "20px 0" },
          },
          children: [
            // Header
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "msg-box-header",
              styles: {
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "26px 0",
              },
              responsiveStyles: {
                mobile: { gap: "16px 0" },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "WHY YOU NEED THIS",
                  styles: {
                    color: "forground",
                    fontSize: "58.3px",
                    fontWeight: "700",
                    lineHeight: "100%",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "40px" },
                    mobile: { fontSize: "30px" },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Most people who see real transformation use Intellident Pro™ for at least 90 days - and many go even longer.\nBy adding more bottles today, you:",
                  styles: {
                    color: "forground",
                    fontSize: "22px",
                    fontWeight: "400",
                    lineHeight: "150%",
                    textAlign: "center",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "16px" },
                  },
                },
              ],
            },
            // Feature List
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "msg-box-list",
              styles: {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                gap: "35px 0",
                width: "100%",
              },
              responsiveStyles: {
                tablet: { gap: "30px 0" },
                mobile: { gap: "20px 0" },
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "By adding more bottles today, you:",
                  styles: {
                    color: "forground",
                    fontSize: "28px",
                    fontWeight: "400",
                    lineHeight: "100%",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "16px" },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  className: "msg-box-list-container",
                  styles: {},
                  children: [
                    // List items
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        color: "forground",
                        fontSize: "28px",
                        fontWeight: "400",
                        lineHeight: "100%",
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "0 6px",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "20px" },
                        mobile: { fontSize: "16px", lineHeight: "20px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/intellident/group-1.png ",
                          styles: { width: "24px", height: "24px" },
                        },
                        {
                          id: generateId(),
                          type: "text" as ElementType,
                          content:
                            "Avoid the pain of running out just when results are kicking in",
                          styles: {},
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        color: "forground",
                        fontSize: "28px",
                        fontWeight: "400",
                        lineHeight: "100%",
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "0 6px",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "20px" },
                        mobile: { fontSize: "16px", lineHeight: "20px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/intellident/group-1.png ",
                          styles: { width: "24px", height: "24px" },
                        },
                        {
                          id: generateId(),
                          type: "text" as ElementType,
                          content:
                            "Lock in this one-time VIP pricing (you won't see $29/bottle again)",
                          styles: {},
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        color: "forground",
                        fontSize: "28px",
                        fontWeight: "400",
                        lineHeight: "100%",
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "0 6px",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "20px" },
                        mobile: { fontSize: "16px", lineHeight: "20px" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/intellident/group-1.png ",
                          styles: { width: "24px", height: "24px" },
                        },
                        {
                          id: generateId(),
                          type: "text" as ElementType,
                          content:
                            "Get ahead of potential stock shortages or price hike",
                          styles: {},
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // Pointers Container
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "pointers-container",
              styles: {
                display: "flex",
                alignItems: "stretch",
                justifyContent: "center",
                gap: "0 50px",
              },
              responsiveStyles: {
                tablet: { flexDirection: "column", gap: "30px 0" },
                mobile: { gap: "20px 0", flexDirection: "column" },
              },
              children: [
                // Doctor Image
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "400px",
                    height: "100%",
                  },
                  responsiveStyles: {
                    tablet: { width: "100%", height: "100%" },
                    mobile: { width: "100%", height: "100%" },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/intellident/doc1.webp",
                      alt: "Doctor",
                      styles: {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      },
                      responsiveStyles: {
                        tablet: {
                          maxWidth: "100%",
                          height: "100%",
                          objectFit: "contain",
                        },
                        mobile: {
                          maxWidth: "100%",
                          height: "100%",
                          objectFit: "cover",
                        },
                      },
                    },
                  ],
                },
                // Pointers List
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  className: "pointers",
                  styles: {
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "flex-start",
                    flexDirection: "column",
                    gap: "20px",
                    flex: "1",
                  },
                  responsiveStyles: {
                    tablet: { gap: "8px 0" },
                  },
                  children: [
                    // Thanking Message
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      className: "thanking-msg",
                      content: "Thank you for ordering but…",
                      styles: {
                        color: "forground",
                        fontSize: "44px",
                        fontWeight: "700",
                        lineHeight: "100%",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "40px", textAlign: "center" },
                        mobile: { fontSize: "30px" },
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "Thank you for beginning your journey with Intellident Pro™ - I truly appreciate your trust. One bottle is a strong start, but real neurological and oral transformation takes time. If you stop too early, your body may lose the momentum it's just starting to build. It's like rewiring the brain halfway, only to leave it unfinished.",
                      styles: {
                        color: "#231F20",
                        fontSize: "22px",
                        fontWeight: "400",
                        lineHeight: "1.2",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "20px", lineHeight: "28px" },
                        mobile: { fontSize: "16px", lineHeight: "24px" },
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "I've seen it happen too often - people feel clearer, sharper, and more energized... then run out, and slowly regress. That's why I always recommend at least 90 days of consistent support to experience lasting results.",
                      styles: {
                        color: "#231F20",
                        fontSize: "22px",
                        fontWeight: "400",
                        lineHeight: "1.2",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "20px", lineHeight: "28px" },
                        mobile: { fontSize: "16px", lineHeight: "24px" },
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "Right now, you have the rare opportunity to secure extra bottles at the deepest discount we'll ever offer. If you're able, grab them now - and protect the progress your body has already begun.",
                      styles: {
                        color: "#231F20",
                        fontSize: "22px",
                        fontWeight: "400",
                        lineHeight: "1.2",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "20px", lineHeight: "28px" },
                        mobile: { fontSize: "16px", lineHeight: "24px" },
                      },
                    },
                    // Signature
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      className: "signature",
                      content: "Dr. Michael Turner",
                      styles: {
                        fontSize: "1.875rem",
                        fontFamily: "Allura, cursive",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "30px", lineHeight: "42px" },
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      className: "signature",
                      content: "Lead Researcher, Intellident ProTM",
                      styles: {
                        fontSize: "18px",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "16px", lineHeight: "24px" },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

// ====================== Guarantee Banner Section ======================
const guaranteeBannerSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "banner",
  styles: {
    backgroundImage:
      "linear-gradient(to right, #1e9dc8 60%, #65c6e7 80%, #37b4e1 90%)",
    fontFamily: "SF Pro Display, sans-serif",
    width: "100%",
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "container",
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 16px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "banner-container",
          styles: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "18px 0",
            maxWidth: "1120px",
            margin: "0 auto",
            width: "100%",
            gap: "32px",
          },
          responsiveStyles: {
            mobile: { flexDirection: "column-reverse", gap: "0" },
          },
          children: [
            // Heading
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "PROTECTED BY 60 DAY 100% MONEY BACK GUARANTEE!",
              styles: {
                color: "background",
                fontSize: "40px",
                fontWeight: "700",
                fontStyle: "normal",
                lineHeight: "70.033px",
                margin: "0",
              },
              typography: "Heading-4",
              responsiveStyles: {
                tablet: { fontSize: "28px", lineHeight: "32px" },
                mobile: {
                  fontSize: "20px",
                  lineHeight: "24px",
                  textAlign: "center",
                },
              },
            },
            // Image
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "img-container",
              styles: {
                maxWidth: "275px",
                width: "100%",
                position: "relative",
                minHeight: "120px",
              },
              responsiveStyles: {
                tablet: { maxWidth: "200px", width: "100%" },
                mobile: { maxWidth: "100px", width: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/intellident/Money Back Guarantee (1).png",
                  alt: "Money Back Guarantee",
                  styles: {
                    position: "absolute",
                    left: "0",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "100%",
                    height: "auto",
                  },
                  responsiveStyles: {
                    tablet: {
                      maxWidth: "200px",
                      width: "100%",
                      position: "relative",
                      top: "0",
                      transform: "none",
                    },
                    mobile: {
                      maxWidth: "100px",
                      width: "100%",
                      position: "relative",
                      top: "0",
                      transform: "none",
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

// ====================== List Notes Section ======================
const listNotesSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "list-notes",
  styles: {
    margin: "50px 0 100px",
    width: "100%",
  },
  responsiveStyles: {
    tablet: { margin: "30px 0 50px" },
    mobile: { margin: "30px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "container",
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 16px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "list-notes-container",
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "42px 0",
          },
          responsiveStyles: {
            tablet: { gap: "30px 0" },
            mobile: { gap: "16px 0" },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: "Try It Risk-Free for a Full 60 Days",
              styles: {
                color: "#231F20",
                fontSize: "30px",
                fontWeight: "700",
                lineHeight: "36px",
                textAlign: "center",
                margin: "0",
              },
              responsiveStyles: {
                tablet: { fontSize: "24px" },
                mobile: { fontSize: "18px", lineHeight: "22px" },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: `We stand behind FortiGold 100%. That's why every bottle you order today is protected by our <b>no-questions-asked 60 day guarantee.</b>`,
              styles: {
                color: "#231F20",
                fontSize: "28px",
                fontWeight: "400",
                lineHeight: "32px",
                textAlign: "center",
                margin: "0",
              },
              responsiveStyles: {
                tablet: { fontSize: "24px" },
                mobile: { fontSize: "18px", lineHeight: "22px" },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: `If you don't feel a real difference - more energy, stronger digestion, better health overall - just let us know. You'll get a full refund, even if the bottles are empty.`,
              styles: {
                color: "#231F20",
                fontSize: "28px",
                fontWeight: "400",
                lineHeight: "100%",
                textAlign: "center",
                margin: "0",
              },
              responsiveStyles: {
                tablet: { fontSize: "24px" },
                mobile: { fontSize: "18px", lineHeight: "22px" },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: "No stress. No hassle.",
              styles: {
                color: "#231F20",
                fontSize: "28px",
                fontWeight: "400",
                lineHeight: "100%",
                textAlign: "center",
                margin: "0",
              },
              responsiveStyles: {
                tablet: { fontSize: "24px" },
                mobile: { fontSize: "18px", lineHeight: "22px" },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "So why not give your body the time it needs to truly benefit?",
              styles: {
                color: "#231F20",
                fontSize: "28px",
                fontWeight: "400",
                lineHeight: "100%",
                textAlign: "center",
                margin: "0",
              },
              responsiveStyles: {
                tablet: { fontSize: "24px" },
                mobile: { fontSize: "18px", lineHeight: "22px" },
              },
            },
          ],
        },
      ],
    },
  ],
});

// ====================== VIP Bonuses Section ======================
const createBonusSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "bonus-section",
  styles: {
    padding: "40px 16px",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
  },
  responsiveStyles: {
    tablet: { padding: "30px 16px" },
    mobile: { padding: "25px 16px" },
  },
  children: [
    // Header
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "bonus-header",
      styles: {
        textAlign: "center",
        marginBottom: "24px",
        maxWidth: "800px",
        marginLeft: "auto",
        marginRight: "auto",
      },
      children: [
        {
          id: generateId(),
          type: "heading" as ElementType,
          content:
            'Unlock Exclusive Bonuses -<br>Yours <span style="color:#000000;">FREE</span> With Your Order!',
          styles: {
            fontSize: "48px",
            fontFamily: 'SFProDisplay-Bold", sans-serif',
            fontWeight: "700",
            color: "forground",
            marginBottom: "16px",
            lineHeight: "1.2",
          },
          typography: "Heading-3",
          responsiveStyles: {
            tablet: { fontSize: "40px" },
            mobile: { fontSize: "32px" },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Gain expert knowledge to boost brain power, support oral health, <br>and stay sharp for years to come - at no extra cost!",
          styles: {
            fontSize: "24px",
            color: "forground",
            marginBottom: "32px",
            maxWidth: "500px",
            marginLeft: "auto",
            marginRight: "auto",
            lineHeight: "1.4",
          },
          responsiveStyles: {
            tablet: { fontSize: "20px" },
            mobile: { fontSize: "18px" },
          },
        },
      ],
    },
    // Red Banner
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "red-banner",
      styles: {
        display: "flex",
        justifyContent: "center",
        marginBottom: "32px",
        width: "100%",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "ribbon-container",
          styles: {
            display: "flex",
            alignItems: "center",
            position: "relative",
          },
          children: [
            // Optional: Left Tail
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "50px",
                height: "52px",
                display: "block",
                marginRight: "-25px",
                backgroundColor: "background",
                zIndex: "10",
                transform: "rotate(45deg)",
              },
              responsiveStyles: {
                mobile: { width: "28px", height: "28px", marginRight: "-13px" },
                tablet: { width: "34px", height: "37px", marginRight: "-17px" },
              },
            },
            // Main Ribbon
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "ribbon",
              styles: {
                backgroudColor: "#9b1c1c",
                backgroundImage:
                  "linear-gradient(90deg, #ff2d2d 0%, #c80000 100%)",
                padding: "18px 48px",
                color: "background",
                fontSize: "2rem",
                fontWeight: "900",
                fontFamily: "SFProDisplay-Bold, sans-serif",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                textAlign: "center",
                lineHeight: "1.1",
                zIndex: 2,
                minWidth: "320px",
                maxWidth: "100%",
                margin: "0",
                position: "relative",
              },
              responsiveStyles: {
                tablet: { fontSize: "1.5rem", padding: "14px 28px" },
                mobile: {
                  fontSize: "1.1rem",
                  padding: "10px 10px",
                  minWidth: "180px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "• GET 2 FREE BONUS BOOKS!!! •",
                  styles: {
                    color: "background",
                    fontWeight: "900",
                    fontFamily: 'SFProDisplay-Bold", sans-serif',
                    fontSize: "inherit",
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                  },
                  responsiveStyles: {
                    mobile: { fontSize: "13px" },
                    tablet: { fontSize: "20px" },
                  },
                },
              ],
            },
            // Optional: Right Tail
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "50px",
                height: "52px",
                display: "block",
                marginLeft: "-25px",
                backgroundColor: "background",
                zIndex: "10",
                transform: "rotate(45deg)",
              },
              responsiveStyles: {
                mobile: { width: "28px", height: "28px", marginLeft: "-13px" },
                tablet: { width: "34px", height: "37px", marginLeft: "-17px" },
              },
            },
          ],
        },
      ],
    },
    // Bonus Books Grid
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "bonus-books-grid",
      styles: {
        display: "grid",
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: "40px",
        maxWidth: "350px",
        margin: "0 auto 32px auto",
      },
      responsiveStyles: {
        tablet: { gap: "0", marginBottom: "28px", maxWidth: "100%" },
        mobile: {
          gap: "16px",
          marginBottom: "24px",
          maxWidth: "100%",
        },
      },
      children: [
        // Bonus Book 1
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "bonus-book-1",
          styles: {
            backgroundColor: "background",
            borderRadius: "24px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            border: "1px solid #d1d5db",
            maxWidth: "100%",
            margin: "0 auto",
            width: "100%",
          },
          responsiveStyles: {
            mobile: { maxWidth: "350px" },
            tablet: { maxWidth: "350px" },
          },
          children: [
            // Book Cover
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "book-cover",
              styles: {
                position: "relative",
                width: "100%",
                height: "400px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/intellident/Asset21.webp",
                  alt: "Think Young Again",
                  styles: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "all 0.3s ease-in-out",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: "96px",
                    height: "96px",
                    transform: "translate(0, 0)",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/intellident/Asset23.webp",
                      alt: "Overlay Image",
                      styles: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      },
                    },
                  ],
                },
              ],
            },
            // Book Info
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "book-info",
              styles: {
                backgroundImage:
                  "linear-gradient(135deg, #87ceeb 0%, #1e9dc8 100%)",
                color: "background",
                padding: "12px 8px",
                textAlign: "center",
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content:
                    "Bonus #1 - Think Young Again:<br>How Healthy Gums Lead To<br>Razor-Sharp Memory",
                  styles: {
                    fontSize: "20px",
                    fontFamily: "pro-display-medium, sans-serif",
                    fontWeight: "500",
                    lineHeight: "1.3",
                    margin: 0,
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "18px" },
                    mobile: { fontSize: "16px" },
                  },
                },
              ],
            },
            // Price Section
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "price-section",
              styles: {
                backgroundColor: "#10b981",
                color: "background",
                padding: "8px",
                textAlign: "center",
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    '<span style="text-decoration:line-through;opacity:0.9;font-family:pro-display-medium,sans-serif;font-weight:500;">$67</span> <span style="color:#f9ed32;">Today: <span style="color:#ffffff;font-family:pro-display-bold,sans-serif;font-weight:700;">FREE</span></span>',
                  styles: {
                    fontSize: "20px",
                    fontFamily: "pro-display-medium, sans-serif",
                    fontWeight: "500",
                    margin: 0,
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "18px" },
                    mobile: { fontSize: "16px" },
                  },
                },
              ],
            },
            // Description
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "book-description",
              styles: {
                padding: "16px",
                textAlign: "center",
                backgroundColor: "#f3f4f6",
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    'Discover the shocking connection<br>between <span style="font-family:pro-display-semi-bold,sans-serif;font-weight:600;">oral health and memory</span>,<br>backed by real stories and research.<br>Learn <span style="font-family:pro-display-semi-bold,sans-serif;font-weight:600;">simple, science-backed<br>steps</span> to keep your brain sharp and<br>gums healthy for life.',
                  styles: {
                    color: "#374151",
                    fontSize: "16px",
                    lineHeight: "1.6",
                    margin: 0,
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "14px" },
                    mobile: { fontSize: "12px" },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    // Top Order Button
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "order-button-container",
      styles: {
        textAlign: "center",
        marginBottom: "24px",
      },
      children: [
        {
          id: generateId(),
          type: "button" as ElementType,
          className: "pack-btn",
          content: "ORDER NOW",
          styles: {
            backgroundImage:
              "conic-gradient(from 54deg at 28% 100%, #f49d00 5.4deg, #f49d00 196.20001deg, #fed159 360deg)",
            color: "forground",
            fontSize: "24px",
            fontWeight: "bold",
            padding: "8px 16px",
            border: "1px solid rgba(241, 210, 68, 0.92)",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            transition: "all 0.3s ease",
            cursor: "pointer",
          },
          responsiveStyles: {
            tablet: { fontSize: "18px", padding: "10px 28px" },
            mobile: { fontSize: "16px", padding: "8px 24px" },
          },
          onClick: { scrollToId: "packages", behavior: "smooth" },
        },
      ],
    },
    // Claim Text
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "claim-text",
      styles: {
        textAlign: "center",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Claim Your FREE Bonuses While Supplies Last!",
          styles: {
            fontSize: "20px",
            fontFamily: "pro-display-regular-italic, sans-serif",
            fontStyle: "italic",
            color: "forground",
            margin: 0,
          },
          responsiveStyles: {
            tablet: { fontSize: "18px" },
            mobile: { fontSize: "16px" },
          },
        },
      ],
    },
  ],
});

// ====================== Customer Review Section ======================
const createCustomerReviewSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "customer-review-section",
  styles: {
    maxWidth: "1200px",
    margin: "0 auto",
    textAlign: "center",
    paddingTop: "2rem",
    paddingBottom: "1rem",
    paddingLeft: "12px",
    paddingRight: "12px",
  },
  responsiveStyles: {
    tablet: { paddingLeft: "8px", paddingRight: "8px" },
    mobile: { paddingLeft: "16px", paddingRight: "16px", paddingTop: "1rem" },
  },
  children: [
    //section title
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "section-title",
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "32px",
      },
      children: [
        {
          id: generateId(),
          type: "heading" as ElementType,
          content: "JOIN COUNTLESS OTHERS WHO STACKED UP",
          styles: {
            fontSize: "50px",
            fontWeight: "700",
            color: "#222",
            fontFamily: "pro-display-regular, sans-serif",
          },
          responsiveStyles: {
            tablet: { fontSize: "32px", lineHeight: "36px" },
            mobile: { fontSize: "24px", lineHeight: "28px" },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "<b>Countless happy users</b> have already gone all-in with Intellident Pro.",
          styles: {
            fontSize: "28px",
            fontFamily: 'SFProDisplay-Bold", sans-serif',
            fontWeight: "700",
            margin: "18px 0 0 0",
            lineHeight: "1.1",
            maxWidth: "900px",
          },
          responsiveStyles: {
            tablet: { fontSize: "20px", lineHeight: "24px", maxWidth: "100%" },
            mobile: { fontSize: "16px", lineHeight: "20px", maxWidth: "100%" },
          },
        },
      ],
    },
    // Headline and 5-star badge (new design)
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "review-header-block",
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "18px",
        marginBottom: "32px",
      },
      responsiveStyles: {
        tablet: { gap: "14px", marginBottom: "24px" },
        mobile: { gap: "12px", marginBottom: "20px" },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Our Customer say",
          styles: {
            fontSize: "2rem",
            color: "#222",
            fontFamily: "pro-display-regular, sans-serif",
            margin: "0 0 8px 0",
          },
          responsiveStyles: {
            tablet: { fontSize: "1.6rem" },
            mobile: { fontSize: "1.3rem" },
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundImage:
              "conic-gradient(from 54deg at 28% 100%, #f49d00 5.4deg, #f49d00 196.20001deg, #fed159 360deg)",
            color: "forground",
            fontSize: "24px",
            fontWeight: "bold",
            padding: "8px 16px",
            border: "1px solid rgba(241, 210, 68, 0.92)",
            borderRadius: "14px",
            margin: "0 0 12px 0",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(255, 193, 7, 0.18)",
          },
          responsiveStyles: {
            tablet: { fontSize: "20px", padding: "6px 12px" },
            mobile: { fontSize: "18px", padding: "5px 10px" },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "5 STAR RATING",
              styles: {
                fontSize: "2rem",
                fontWeight: "700",
                color: "#222",
                letterSpacing: "0.04em",
                margin: 0,
                fontFamily: 'SFProDisplay-Bold", sans-serif',
              },
              responsiveStyles: {
                tablet: { fontSize: "1.6rem" },
                mobile: { fontSize: "1.3rem" },
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            justifyContent: "center",
            gap: "18px",
            margin: "0 0 12px 0",
          },
          responsiveStyles: {
            tablet: { gap: "14px" },
            mobile: { gap: "10px" },
          },
          children: Array(5)
            .fill(0)
            .map(() => ({
              id: generateId(),
              type: "image" as ElementType,
              src: "/intellident/group-15.webp",
              alt: "star",
              styles: { width: "54px", height: "54px", objectFit: "contain" },
              responsiveStyles: {
                tablet: { width: "44px", height: "44px" },
                mobile: { width: "36px", height: "36px" },
              },
            })),
        },
        {
          id: generateId(),
          type: "heading" as ElementType,
          content: "<b>Countless Five-Star Reviews</b> and Counting!",
          styles: {
            fontSize: "2.2rem",
            color: "#222",
            fontFamily: 'SFProDisplay-Bold", sans-serif',
            fontWeight: "500",
            margin: "18px 0 0 0",
          },
          responsiveStyles: {
            tablet: { fontSize: "1.8rem" },
            mobile: { fontSize: "1.4rem" },
          },
        },
        {
          id: generateId(),
          type: "heading" as ElementType,
          content:
            'Many People Are Experiencing the <span style="color:#00bfff;">INTELLIDENT PRO™</span> Difference',
          styles: {
            fontSize: "3.2rem",
            fontFamily: 'SFProDisplay-Bold", sans-serif',
            fontWeight: "700",
            margin: "18px 0 0 0",
            lineHeight: "1.1",
            maxWidth: "900px",
          },
          responsiveStyles: {
            tablet: { fontSize: "2.4rem", maxWidth: "100%" },
            mobile: { fontSize: "1.8rem", maxWidth: "100%" },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Real people. Real results. A healthier mind and mouth - starting in just days.",
          styles: {
            fontSize: "1.25rem",
            color: "#222",
            fontFamily: "pro-display-regular, sans-serif",
            margin: "10px 0 0 0",
          },
          responsiveStyles: {
            tablet: { fontSize: "1.1rem" },
            mobile: { fontSize: "1rem" },
          },
        },
      ],
    },
    // Polaroid Photo (single image)
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "client-photo-container",
      styles: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "2.5rem 0 2.5rem 0",
      },
      responsiveStyles: {
        tablet: { margin: "2rem 0 2rem 0" },
        mobile: { margin: "1.5rem 0 1.5rem 0" },
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/intellident/client-photo.png",
          alt: "Happy customers holding INTELLIDENT PRO",
          styles: {
            width: "100%",
            maxWidth: "900px",
            height: "auto",
            filter: "drop-shadow(0 0 5px rgba(0,0,0,0.18))",
          },
          responsiveStyles: {
            tablet: { maxWidth: "100%" },
            mobile: { maxWidth: "100%" },
          },
        },
      ],
    },
    // Testimonial Responsive Section
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 24px",
        fontFamily: "pro-display-light, sans-serif",
      },
      responsiveStyles: {
        tablet: { padding: "0 16px" },
        mobile: { padding: "0 8px" },
      },
      children: [
        // Testimonial 1 - Leah T.
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "2rem",
            justifyContent: "center",
            background: "rgba(255,255,255,0.5)",
            borderRadius: "16px",
            padding: "1.5rem",
            marginBottom: "1.5rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          },
          responsiveStyles: {
            tablet: { flexDirection: "column", gap: "1rem", padding: "1.2rem" },
            mobile: {
              flexDirection: "column",
              gap: "0.8rem",
              padding: "1rem",
              borderRadius: "12px",
            },
          },
          children: [
            // Profile Photo
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                flexShrink: 0,
                width: "112px",
                height: "112px",
                borderRadius: "50%",
                overflow: "hidden",
                background: "#e5e7eb",
              },
              responsiveStyles: {
                tablet: { width: "96px", height: "96px" },
                mobile: { width: "80px", height: "80px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/intellident/Asset27.webp",
                  alt: "Leah T. profile photo",
                  styles: { width: "100%", height: "100%", objectFit: "cover" },
                },
              ],
            },
            // Testimonial Content
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: { flex: 1, textAlign: "left", maxWidth: "800px" },
              responsiveStyles: {
                tablet: { textAlign: "center", maxWidth: "100%" },
                mobile: { textAlign: "center", maxWidth: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    '"I used to deal with brain fog and bad breath that made me feel embarrassed. Now, I can think clearly, stay focused, and feel good about myself every day!"',
                  styles: {
                    fontSize: "20px",
                    lineHeight: "1.5",
                    marginBottom: "1rem",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "18px" },
                    mobile: { fontSize: "16px" },
                  },
                },
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Leah T., 43",
                  styles: {
                    fontSize: "24px",
                    fontFamily: "pro-display-semibold, sans-serif",
                    color: "forground",
                    marginBottom: "1rem",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "18px" },
                  },
                },
                // Stars and Premium Product
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  },
                  responsiveStyles: {
                    tablet: { justifyContent: "center" },
                    mobile: {
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: "0.3rem",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: { display: "flex", gap: "0.2rem" },
                      children: Array(5)
                        .fill(0)
                        .map(() => ({
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/intellident/star.svg",
                          alt: "5 star rating",
                          styles: { width: "20px", height: "20px" },
                          responsiveStyles: {
                            tablet: { width: "18px", height: "18px" },
                            mobile: { width: "16px", height: "16px" },
                          },
                        })),
                    },
                    {
                      id: generateId(),
                      type: "span" as ElementType,
                      content: "Premium Product",
                      styles: { fontSize: "18px", color: "#333" },
                      responsiveStyles: {
                        tablet: { fontSize: "16px" },
                        mobile: { fontSize: "14px" },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        // Testimonial 2 - Mike S.
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "2rem",
            justifyContent: "center",
            background: "rgba(255,255,255,0.5)",
            borderRadius: "16px",
            padding: "1.5rem",
            marginBottom: "1.5rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          },
          responsiveStyles: {
            tablet: { flexDirection: "column", gap: "1rem", padding: "1.2rem" },
            mobile: {
              flexDirection: "column",
              gap: "0.8rem",
              padding: "1rem",
              borderRadius: "12px",
            },
          },
          children: [
            // Profile Photo
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                flexShrink: 0,
                width: "112px",
                height: "112px",
                borderRadius: "50%",
                overflow: "hidden",
                background: "#e5e7eb",
              },
              responsiveStyles: {
                tablet: { width: "96px", height: "96px" },
                mobile: { width: "80px", height: "80px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/intellident/Asset28.webp",
                  alt: "Mike S. profile photo",
                  styles: { width: "100%", height: "100%", objectFit: "cover" },
                },
              ],
            },
            // Testimonial Content
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: { flex: 1, textAlign: "left", maxWidth: "800px" },
              responsiveStyles: {
                tablet: { textAlign: "center", maxWidth: "100%" },
                mobile: { textAlign: "center", maxWidth: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    '"I used to forget names all the time, which wasn\'t great for my work. Ever since I started using Intelligent Pro™, my memory is sharper, and my gums feel healthier too!"',
                  styles: {
                    fontSize: "20px",
                    lineHeight: "1.5",
                    marginBottom: "1rem",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "18px" },
                    mobile: { fontSize: "16px" },
                  },
                },
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Mike S., 48",
                  styles: {
                    fontSize: "24px",
                    fontFamily: "pro-display-semibold, sans-serif",
                    color: "forground",
                    marginBottom: "1rem",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "18px" },
                  },
                },
                // Stars and Premium Product
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  },
                  responsiveStyles: {
                    tablet: { justifyContent: "center" },
                    mobile: {
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: "0.3rem",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: { display: "flex", gap: "0.2rem" },
                      children: Array(5)
                        .fill(0)
                        .map(() => ({
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/intellident/star.svg",
                          alt: "5 star rating",
                          styles: { width: "20px", height: "20px" },
                          responsiveStyles: {
                            tablet: { width: "18px", height: "18px" },
                            mobile: { width: "16px", height: "16px" },
                          },
                        })),
                    },
                    {
                      id: generateId(),
                      type: "span" as ElementType,
                      content: "Premium Product",
                      styles: { fontSize: "18px", color: "#333" },
                      responsiveStyles: {
                        tablet: { fontSize: "16px" },
                        mobile: { fontSize: "14px" },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        // Testimonial 3 - Mary J.
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "2rem",
            justifyContent: "center",
            background: "rgba(255,255,255,0.5)",
            borderRadius: "16px",
            padding: "1.5rem",
            marginBottom: "1.5rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          },
          responsiveStyles: {
            tablet: { flexDirection: "column", gap: "1rem", padding: "1.2rem" },
            mobile: {
              flexDirection: "column",
              gap: "0.8rem",
              padding: "1rem",
              borderRadius: "12px",
            },
          },
          children: [
            // Profile Photo
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                flexShrink: 0,
                width: "112px",
                height: "112px",
                borderRadius: "50%",
                overflow: "hidden",
                background: "#e5e7eb",
              },
              responsiveStyles: {
                tablet: { width: "96px", height: "96px" },
                mobile: { width: "80px", height: "80px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/intellident/Asset29.webp",
                  alt: "Mary J. profile photo",
                  styles: { width: "100%", height: "100%", objectFit: "cover" },
                },
              ],
            },
            // Testimonial Content
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: { flex: 1, textAlign: "left", maxWidth: "800px" },
              responsiveStyles: {
                tablet: { textAlign: "center", maxWidth: "100%" },
                mobile: { textAlign: "center", maxWidth: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    '"I was scared of losing my memory like my dad. But after using Intelligent Pro™, I think more clearly, have more energy, and my breath stays fresh all day."',
                  styles: {
                    fontSize: "20px",
                    lineHeight: "1.5",
                    marginBottom: "1rem",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "18px" },
                    mobile: { fontSize: "16px" },
                  },
                },
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Mary J., 36",
                  styles: {
                    fontSize: "24px",
                    fontFamily: "pro-display-semibold, sans-serif",
                    color: "forground",
                    marginBottom: "1rem",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                    mobile: { fontSize: "18px" },
                  },
                },
                // Stars and Premium Product
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  },
                  responsiveStyles: {
                    tablet: { justifyContent: "center" },
                    mobile: {
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: "0.3rem",
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: { display: "flex", gap: "0.2rem" },
                      children: Array(5)
                        .fill(0)
                        .map(() => ({
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/intellident/star.svg",
                          alt: "5 star rating",
                          styles: { width: "20px", height: "20px" },
                          responsiveStyles: {
                            tablet: { width: "18px", height: "18px" },
                            mobile: { width: "16px", height: "16px" },
                          },
                        })),
                    },
                    {
                      id: generateId(),
                      type: "span" as ElementType,
                      content: "Premium Product",
                      styles: { fontSize: "18px", color: "#333" },
                      responsiveStyles: {
                        tablet: { fontSize: "16px" },
                        mobile: { fontSize: "14px" },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    // Bottom Order Button
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: { textAlign: "center", margin: "2rem 0" },
      responsiveStyles: {
        tablet: { margin: "1.5rem 0" },
        mobile: { margin: "1rem 0" },
      },
      children: [
        {
          id: generateId(),
          type: "button" as ElementType,
          className: "order-btn",
          content: "ORDER NOW",
          styles: {
            backgroundImage:
              "conic-gradient(from 54deg at 28% 100%, #f49d00 5.4deg, #f49d00 196.20001deg, #fed159 360deg)",
            color: "forground",
            fontSize: "24px",
            fontWeight: "bold",
            padding: "8px 16px",
            border: "1px solid rgba(241, 210, 68, 0.92)",
            borderRadius: "8px",
            cursor: "pointer",
            margin: "0 auto",
            textTransform: "uppercase",
            letterSpacing: "1px",
            transition: "all 0.3s ease",
            display: "inline-block",
            boxShadow: "0 4px 15px rgba(255, 140, 0, 0.3)",
          },
          responsiveStyles: {
            tablet: { fontSize: "20px", padding: "6px 12px" },
            mobile: { fontSize: "18px", padding: "5px 10px" },
          },
          onClick: { scrollToId: "packages", behavior: "smooth" },
        },
      ],
    },
    // Bottom Text
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: { textAlign: "center", padding: "1rem 0" },
      responsiveStyles: {
        tablet: { padding: "0.8rem 0" },
        mobile: { padding: "0.6rem 0" },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Experience the Benefits Yourself!",
          styles: { fontSize: "20px", color: "#333" },
          responsiveStyles: {
            tablet: { fontSize: "18px" },
            mobile: { fontSize: "16px" },
          },
        },
      ],
    },
  ],
});

// ====================== Guarantee Section ======================
const createGuaranteeSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "guarantee-section",
  styles: { width: "100%" },
  children: [
    // Blue Section Three
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "linear-blue-gradient1",
      styles: {
        backgroundImage:
          "linear-gradient(to right, #65c6e7 30%, #37b4e1 60%, #1e9ac8 80%)",
        width: "100%",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            padding: "3.5rem 0",
            maxWidth: "1000px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1.5rem",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "row",
              gap: "1.5rem",
              padding: "2rem 1rem",
            },
            mobile: {
              padding: "2rem 1rem",
              gap: "1rem",
              flexDirection: "column",
            },
          },
          children: [
            // Golden Badge
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: { flexShrink: 0 },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/intellident/Asset-6.webp",
                  alt: "Golden Badge",
                  styles: { width: "208px", height: "auto" },
                  responsiveStyles: {
                    tablet: { width: "192px" },
                    mobile: { width: "128px" },
                  },
                },
              ],
            },
            // Text Content
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: { flex: 1 },
              responsiveStyles: {
                tablet: { textAlign: "left" },
                mobile: { textAlign: "center" },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Limited Supply Available",
                  styles: {
                    fontSize: "3rem",
                    fontFamily: 'SFProDisplay-Bold", sans-serif',
                    color: "background",
                    marginBottom: "1rem",
                    lineHeight: "1.2",
                    fontWeight: "700",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "2rem", marginBottom: "0.75rem" },
                    mobile: {
                      fontSize: "1.5rem",
                      marginBottom: "0.5rem",
                      textAlign: "center",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Selling Out Fast!",
                  styles: {
                    fontSize: "2.25rem",
                    fontFamily: "pro-display-semibold-italic, sans-serif",
                    marginBottom: "1.5rem",
                    color: "quaternary",
                    letterSpacing: "0.02em",
                    fontWeight: "600",
                    fontStyle: "italic",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "2rem", marginBottom: "1rem" },
                    mobile: { fontSize: "1.5rem", marginBottom: "0.75rem" },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    'Due to <span style="font-family:pro-display-bold; font-weight:700;">high demand</span>, INTELLIDENT PRO™ is selling out faster than expected. <span style="font-family:pro-display-light; font-weight:300;">Once this batch is gone, restocking could take months.</span>',
                  styles: {
                    fontSize: "1.5rem",
                    color: "background",
                    lineHeight: "1.5",
                    fontFamily: "pro-display-light, sans-serif",
                    letterSpacing: "0.02em",
                    marginBottom: "1rem",
                    fontWeight: "300",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "1.5rem", marginBottom: "0.75rem" },
                    mobile: { fontSize: "1rem", marginBottom: "0.5rem" },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Order now while supplies last!",
                  styles: {
                    fontSize: "1.5rem",
                    color: "background",
                    lineHeight: "1.5",
                    fontFamily: "pro-display-bold-italic, sans-serif",
                    letterSpacing: "0.02em",
                    fontWeight: "600",
                    fontStyle: "italic",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "1.5rem" },
                    mobile: { fontSize: "1rem" },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

// ====================== Footer Section ======================
const createFooterSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "footer-section",
  styles: {
    width: "100%",
  },
  children: [
    // Navigation Footer
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "foot",
      styles: {
        backgroundColor: "#37b4e1",
        padding: "20px 0",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "foot-container",
          styles: {
            maxWidth: "1200px",
            margin: "0 auto",
            paddingLeft: "16px",
            paddingRight: "16px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "foot-nav",
              styles: {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                gap: "24px",
              },
              responsiveStyles: {
                tablet: { gap: "32px" },
                mobile: {
                  gap: "8px",
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "link" as ElementType,
                  className: "foot1",
                  content: "Privacy",
                  href: "/privacy",
                  styles: {
                    color: "background",
                    fontSize: "20px",
                    padding: "6px 8px",
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                    fontFamily: "pro-display-regular, sans-serif",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "22px" },
                    mobile: { fontSize: "16px" },
                  },
                  hoverStyles: {
                    color: "rgba(255, 255, 255, 0.9)",
                  },
                },
                {
                  id: generateId(),
                  type: "link" as ElementType,
                  className: "foot1",
                  content: "Terms & Condition",
                  href: "/terms",
                  styles: {
                    color: "background",
                    fontSize: "20px",
                    padding: "6px 8px",
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                    fontFamily: "pro-display-regular, sans-serif",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "22px" },
                    mobile: { fontSize: "16px" },
                  },
                  hoverStyles: {
                    color: "rgba(255, 255, 255, 0.9)",
                  },
                },
                {
                  id: generateId(),
                  type: "link" as ElementType,
                  className: "foot1",
                  content: "Disclaimer",
                  href: "/disclaimer",
                  styles: {
                    color: "background",
                    fontSize: "20px",
                    padding: "6px 8px",
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                    fontFamily: "pro-display-regular, sans-serif",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "22px" },
                    mobile: { fontSize: "16px" },
                  },
                  hoverStyles: {
                    color: "rgba(255, 255, 255, 0.9)",
                  },
                },
                {
                  id: generateId(),
                  type: "link" as ElementType,
                  className: "foot1",
                  content: "Returns & Refunds",
                  href: "/returns",
                  styles: {
                    color: "background",
                    fontSize: "20px",
                    padding: "6px 8px",
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                    fontFamily: "pro-display-regular, sans-serif",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "22px" },
                    mobile: { fontSize: "16px" },
                  },
                  hoverStyles: {
                    color: "rgba(255, 255, 255, 0.9)",
                  },
                },
                {
                  id: generateId(),
                  type: "link" as ElementType,
                  className: "foot1",
                  content: "Contact",
                  href: "/contact",
                  styles: {
                    color: "background",
                    fontSize: "20px",
                    padding: "6px 8px",
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                    fontFamily: "pro-display-regular, sans-serif",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "22px" },
                    mobile: { fontSize: "16px" },
                  },
                  hoverStyles: {
                    color: "rgba(255, 255, 255, 0.9)",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    // Disclaimer Footer
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "disclaimer-footer",
      styles: {
        backgroundColor: "background",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "disclaimer-container",
          styles: {
            maxWidth: "1200px",
            margin: "0 auto",
            paddingTop: "40px",
            paddingBottom: "40px",
            paddingLeft: "8px",
            paddingRight: "8px",
          },
          responsiveStyles: {
            tablet: { paddingLeft: "8px", paddingRight: "8px" },
            mobile: { paddingLeft: "8px", paddingRight: "8px" },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "disclaimer-content",
              styles: {
                color: "#374151",
                fontSize: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                fontFamily: "pro-display-light, sans-serif",
                fontWeight: "500",
              },
              responsiveStyles: {
                tablet: { fontSize: "16px" },
                mobile: { fontSize: "17px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. The information presented on this site is for informational purposes only and is not a substitute for advice from your physician or other healthcare professional.",
                  styles: {
                    margin: 0,
                    lineHeight: "1.6",
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Always consult with a qualified healthcare provider before beginning any diet, supplement, or exercise program.",
                  styles: {
                    textAlign: "center",
                    paddingBottom: "16px",
                    margin: 0,
                    lineHeight: "1.6",
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Individual results may vary. Testimonials and reviews appearing on this site reflect real-life experiences of individuals who used our products. However, results may not be typical and are not guaranteed.",
                  styles: {
                    textAlign: "center",
                    paddingBottom: "16px",
                    margin: 0,
                    lineHeight: "1.6",
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Copyright © 2024 – 2025 Intellident Pro™. All Rights Reserved.",
                  styles: {
                    textAlign: "center",
                    fontSize: "14px",
                    color: "#374151",
                    margin: 0,
                    lineHeight: "1.6",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "16px" },
                    mobile: { fontSize: "18px" },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

export const template4Upsell = (globalConfig: GlobalConfig) => {
  return {
    alertMsg: alertMsg(globalConfig),
    banner: banner(globalConfig),
    content: content(globalConfig),
    featuresBox: featuresBoxSection(globalConfig),
    featuresBox2: featuresBoxSection(globalConfig),
    msgSection: msgSection(globalConfig),
    guaranteeBanner: guaranteeBannerSection(globalConfig),
    listNotes: listNotesSection(globalConfig),
    vipBonuses: createBonusSection(globalConfig),
    customerReview: createCustomerReviewSection(globalConfig),
    guarantee: createGuaranteeSection(globalConfig),
    listing: createListingSection(globalConfig),
    footer: createFooterSection(globalConfig),
  };
};
